import React, { useContext } from 'react'
import DocumentsOnCaseDetails from './DocumentsOnCaseDetails'
import DownloadIcon from 'Components/Icons/DownloadIcon'
import { Context } from 'Context/Context'
import QcrLoader from 'Components/Icons/QcrLoader';

function DocumentsDownloadOnProfContent({caseDetails, onDownload, isResponseReceived}) {
    const {userDetails} = useContext(Context);
  return (
    <div className='flex flex-col w-full text-sm'>
        <div className='relative shadow-xl border p-4 w-full mr-4'>

        <div className='font-bold text-md  mb-6 underline text-green-700'>Documents Uploaded </div>
        {caseDetails?.isClosed === 1 ?
            (caseDetails?.caseStatus === "closed" && (caseDetails?.supportingDocuments?.length !== 0 || caseDetails?.videoDocument?.length !== 0 )? 
        <div className='absolute top-5 right-5'>
            <div className='text-xs flex rounded text-black cursor-pointer p-2 w-max bg-green-300 ' onClick={()=>onDownload(true)}>Download all&nbsp;<DownloadIcon/></div>
        </div>
        :
        "")
        :
        ((caseDetails?.supportingDocuments?.length !== 0 || caseDetails?.videoDocument?.length !== 0 ) ? 
        <div className='absolute top-5 right-5'>
            <div className='text-xs flex rounded text-black cursor-pointer p-2 w-max bg-green-300 ' 
                onClick={()=>{ return ((isResponseReceived === null || isResponseReceived === false) ? onDownload(false) : '')
                }}
            >
                
                
                {isResponseReceived !== null  ? 
                    (isResponseReceived === true  ? 
                        <span className='flex'>
                            <QcrLoader variant="draw" size="sm" />
                         &nbsp; 
                            Download in progress
                        </span>
                        : <>Download all&nbsp;<DownloadIcon/></>) 
                    : <>Download all&nbsp;<DownloadIcon/></>}
                
                </div>
        </div>
        :
        ''
        )
        }
        <DocumentsOnCaseDetails caseDetails={caseDetails} name={"supportingDocuments"}/>
        <DocumentsOnCaseDetails caseDetails={caseDetails} name={"videoDocument"}/>

    </div>
    </div>
  )
}

export default DocumentsDownloadOnProfContent